import Stars from './Stars';

interface Review {
  id: string;
  user: string;
  rating: number;
  date: string;
  title: string;
  body: string;
}

export default function ReviewCard({ review }: { review: Review }) {
  return (
    <div className="bg-white rounded-xl border border-ink-100 p-5">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-full bg-ink-100 text-ink-700 flex items-center justify-center font-semibold text-sm flex-shrink-0">
            {review.user.charAt(0)}
          </span>
          <div>
            <p className="text-sm font-semibold text-ink-900">{review.user}</p>
            <Stars rating={review.rating} size="sm" />
          </div>
        </div>
        <span className="text-xs text-ink-400 whitespace-nowrap">{review.date}</span>
      </div>
      <h4 className="mt-3 font-semibold text-ink-900 text-sm">{review.title}</h4>
      <p className="mt-2 text-sm text-ink-600 leading-relaxed">{review.body}</p>
    </div>
  );
}